import { render, staticRenderFns } from "./outside-offer.vue?vue&type=template&id=9762a620&scoped=true&"
import script from "./outside-offer.vue?vue&type=script&lang=js&"
export * from "./outside-offer.vue?vue&type=script&lang=js&"
import style0 from "./outside-offer.vue?vue&type=style&index=0&id=9762a620&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9762a620",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
